import { GeoWithCountryName } from '@/app/api/geoip/route';
import { API_GEO_IP } from '@/constants/routes';
import { QualifiedFormData } from '@/types/qualified';
import Script from 'next/script';
import { isPersonalEmail } from './validation';

// Helper to check for window and qualified object
const isQualifiedAvailable = () => {
  return typeof window !== 'undefined' && window.qualified;
};

// See https://www.qualified.com/help-articles/client-side-api#handleEvents
export const handleQualifiedEventListener = (callback: (name: string, data: any) => void) => {
  if (isQualifiedAvailable()) {
    window.qualified("handleEvents", callback);
  }
}


export const amendQualifiedFormData = async (formData: QualifiedFormData) => {
  // Get country IP from our API endpoint at /api/geoip - this uses Vercel Edge Functions
  let ipCountry: string = '';

  const geoIpResponse = await fetch(API_GEO_IP);

  if (geoIpResponse.ok) {
    const { countryName } = (await geoIpResponse.json()) as GeoWithCountryName;

    if (countryName) {
      ipCountry = countryName;
    }
  }
  formData.free_email_domain = String(isPersonalEmail(formData.email));
  formData.ip_country = ipCountry;
  return formData;
}

/*
 * See https://www.qualified.com/help-articles/client-side-api#saveFormData
 * Use care to call this only once per form submission.
 */
export const saveQualifiedFormData = (formData: QualifiedFormData) => {
  if (isQualifiedAvailable()) {
    window.qualified(
      "saveFormData", formData
    );
    // Emit a form fill event to Qualified
    window.qualified("emitFormFill", "custom");
  }
}

//  Wrapper around Qualified's showFormExperience function
export const showQualifiedFormExperience = (formId: string) => {
  if (isQualifiedAvailable()) {
    window.qualified("showFormExperience", formId);
  }
}

// Qualified script tags to be loaded in the layout
export const QualifiedInitScript = (
  <Script
    id="qualified-init"
    strategy="beforeInteractive"
    dangerouslySetInnerHTML={{
      __html: `
          (function(w,q){w['QualifiedObject'] = q;w[q]=w[q]||function(){
            (w[q].q = w[q].q || []).push(arguments)};})(window,'qualified')
        `,
    }}
  />
);

export const QualifiedScript = (
  <Script src="https://js.qualified.com/qualified.js?token=1ma12v8c9weKFaJi" strategy="lazyOnload" />
);
